<form [formGroup]="form" class="cemento-cantidad-servicios-section">
  <div class="cemento-cantidad-servicios-section__row">
    <div class="cemento-cantidad-servicios-section__field">
      <h4 class="cemento-cantidad-servicios-section__field-title">Cantidad de Pallets</h4>
      <div class="cemento-cantidad-servicios-section__field-subtitles">
        <p>Las cantidades disponibles dependen de la ubicación y tipo de entrega. Cada pallet contiene 72 sacos de 25 kg.</p>
        <p>Selecciona la cantidad de pallets que necesitas</p>
      </div>
      <select
        id="quantity"
        class="form-select cemento-cantidad-servicios-section__select"
        formControlName="quantity"
        [class.is-invalid]="form.get('quantity')?.invalid && form.get('quantity')?.touched">
        <option [ngValue]="null" disabled>Cantidad de pallets</option>
        @for (option of palletOptions(); track option.value) {
          <option [ngValue]="option.value">{{ option.label }}</option>
        }
      </select>
      @if (!palletOptions().length) {
        <div class="text-muted small mt-2">
          No hay pallets configurados para este producto.
        </div>
      }
      @if (form.get('quantity')?.invalid && form.get('quantity')?.touched) {
        <div class="invalid-feedback d-block">Seleccione una cantidad válida.</div>
      }
    </div>
  </div>
</form>
